import IconLink from '@picsart/icons/IconLink';
import IconEmbedCode from '@picsart/icons/IconEmbedCode';
import IconFacebookColored from '@picsart/icons/IconFacebookColored';
import IconTwitterColored from '@picsart/icons/IconTwitterColored';
import IconLinkedInColored from '@picsart/icons/IconLinkedInColored';
import IconEmail from '@picsart/icons/IconEmail';

export const shareMethods = [
  {
    name: 'Copy Link',
    value: 'copy_link',
    backgroundColor: 'transparent',
    icon: {
      component: IconLink,
      color: 'var(--x-accent-1-1)',
      borderWidth: 1,
    },
  },
  {
    name: 'Embed',
    value: 'embed',
    backgroundColor: 'transparent',
    icon: {
      component: IconEmbedCode,
      color: 'var(--x-accent-1-1)',
      borderWidth: 1,
    },
  },
  {
    name: 'Facebook',
    value: 'facebook',
    backgroundColor: 'rgba(25, 119, 243, 0.1)',
    icon: {
      component: IconFacebookColored,
      color: '#1977F3',
      width: 30,
      height: 30,
    },
  },
  {
    name: 'Twitter',
    value: 'twitter',
    backgroundColor: 'rgba(45, 170, 225, 0.1)',
    icon: {
      component: IconTwitterColored,
      color: '#2DAAE1',
      width: 30,
      height: 30,
    },
  },
  {
    name: 'LinkedIn',
    value: 'linkedin',
    backgroundColor: 'rgba(10, 123, 186, 0.1)',
    icon: {
      component: IconLinkedInColored,
      color: '#0A7BBA',
      width: 30,
      height: 30,
    },
  },
  {
    name: 'Mail',
    value: 'mail',
    backgroundColor: 'rgba(76, 76, 76, 0.1)',
    icon: {
      component: IconEmail,
      color: '#4C4C4C',
    },
  },
];
